module.exports = __webpack_public_path__ + "static/media/08.c6dc74ee.mp3";